import UIAlert from 'UIComponents/alert/UIAlert';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "DisabledAlertBase__StyledDiv",
  componentId: "sc-242lyw-0"
})(["height:100%;margin:25px;"]);
const DisabledAlertBase = ({
  message,
  type,
  button
}) => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(StyledDiv, {
      children: /*#__PURE__*/_jsxs(UIAlert, {
        type: type,
        children: [message, /*#__PURE__*/_jsx(UIButtonWrapper, {
          className: "m-top-1",
          children: button
        })]
      })
    })
  });
};
DisabledAlertBase.displayName = 'DisabledAlertBase';
export default DisabledAlertBase;